import { Injectable, Injector, TemplateRef, Type } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

type Reference = TemplateRef<any> | Type<any>;

@Injectable()
export class BottomOutletService {
  references$ = new BehaviorSubject<
    { ref: Reference; options?: { injector: Injector } }[]
  >([]);

  append(ref: Reference, options?: { injector: Injector }): void {
    this.references$.next([...this.references$.value, { ref, options }]);
  }

  remove(ref: Reference): void {
    const references = [...this.references$.value];
    const index = references.findIndex((o) => o.ref === ref);
    references.splice(index, 1);
    this.references$.next(references);
  }
}
